import { redirect, createBrowserRouter, RouterProvider, NavLink } from "react-router-dom";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import App from "@/App";
import Login from "@/views/login/Login";
import Register from "@/views/login/Register";
import NotFound from '@/components/NotFound';
import Loading from '@/components/Loading'
import Developing from "@/components/Developing";
import CommodityDetail from "@/views/commodity/detail/CommodityDetail";
import ShopCallback from "@/views/auth/ShopCallback";
import OrderReviewInfo from "@/views/OrderReview/Info";
import OpportunityClues from "@/views/OrderReview/OpportunityClues";
import { list2Tree } from "@/utils/TreeUtils";
import { useEffect, useState } from "react";
const Router = () => {

  let originalMenuData = useSelector(state => state.menu.menus)
  const menuDispatch = useDispatch()

  const routerLoader = () => {
    const isAuthed = localStorage.getItem('token') ? true : false
    if (!isAuthed) {
      throw redirect('/login')
    }
  }

  // 递归生成路由
  const generateRoutes = (menus = []) => {
    return menus.map((menu) => {
      const { componentPath, children, url } = menu
      let Element
      // 尝试异步加载组件
      if (componentPath) {
        const importPromise = import('@/' + `${componentPath}` + '.jsx' || '.js').catch((err) => {
          console.warn(`Failed to load component: ${componentPath}`, err)
          return { default: () => <Developing /> };
        })
        Element = React.lazy(() => importPromise)
      } else {
        Element = () => { return (<Developing />) }
      }
      const newRroute = {
        id: `menu-${menu.id}`,
        element:
          (!children || children.length <= 0) &&
          (<React.Suspense fallback={(<Loading />)}>
            <Element />
          </React.Suspense>),
        path: url ? url.split('?')[0] : url,
      };
      if (children && children.length > 0) {
        newRroute.children = generateRoutes(children);  // 递归生成子路由
      }
      return newRroute;
    });
  };

  // 获取路由配置
  const getRoutes = () => {
    let menusCopy = originalMenuData ? JSON.parse(JSON.stringify(originalMenuData)) : [];
    menusCopy = menusCopy?.filter(item => item.menuType === "1" && item.externalFlag !== "1")

    let menuData = list2Tree(menusCopy, 'id', 'parentId', 'menuOrder')
    if (menuData && menuData.length > 0) {
      const resultRoutes = generateRoutes(menuData);
      const replaceUrl = resultRoutes[0].children?.[0]?.path || resultRoutes[0].path; // 获取重定向地址到第一个菜单
      let data = [
        {
          path: "/",
          loader: () => redirect(replaceUrl), // 重定向
        },
        ...resultRoutes,
      ];
      return data;
    }
    return [];
  }

  const staticRoutes = [
    {
      path: "/login",
      element: <Login />,
    }, {
      path: "/register",
      name: "注册",
      element: <Register />,
    }, {
      path: "*",
      element: <NotFound />,
    }, {
      path: "/commodity/detail",
      name: "商品详情",
      element: <CommodityDetail />,
      loader: routerLoader
    }, {
      path: "/ShopCallback",
      name: "店铺授权",
      element: <ShopCallback />,
      loader: routerLoader
    },
    {
      path: "/OrderReview/Info",
      name: "商品详情",
      element: <OrderReviewInfo />,
      loader: routerLoader
    },
    {
      path: "/OrderReview/OpportunityClues",
      name: "商品商机详情",
      element: <OpportunityClues />,
      loader: routerLoader
    }
  ]

  const [dynamicRoutes, setDynamicRoutes] = useState(staticRoutes)

  useEffect(() => {
    let appendRoutes = {
      path: "/",
      element: <App />,
      children: getRoutes(),
    }
    let newRroutes = [appendRoutes, ...staticRoutes]

    setDynamicRoutes(newRroutes)
  }, [originalMenuData])

  const router = createBrowserRouter(dynamicRoutes, { basename: process.env.PUBLIC_URL });

  useEffect(() => {
    const unsubscribe = router.subscribe((state) => {
      if (state?.historyAction === "PUSH") {
        const matches = state.matches || []
        const openKeys = matches.map(match => match.route.id)
        menuDispatch({
          type: "setOpenKeys",
          data: openKeys
        })
      }
    });
    return unsubscribe;
  }, [router]);

  return (<RouterProvider router={router} />)
}
export default Router;
